var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReviewArrowIcon = function SvgReviewArrowIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M1.682.848c-.239-.01-.417.168-.394.394l.05 1.245c.01.238.202.431.427.427l1.722.07-2.8 2.8c-.153.153-.142.418.023.583l.923.923c.166.166.43.176.583.024l2.788-2.788.082 1.709c.01.238.203.431.427.427l1.245.05c.239.01.417-.168.394-.393L6.956 1.47c-.01-.238-.202-.431-.427-.427L1.682.848Z"
  })));
};
export default SvgReviewArrowIcon;